var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430.6 341.8",
    style: {
      enableBackground: "new 0 0 430.6 341.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0079BE;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.6,172.4C430.6,70.4,345.5,0,252.3,0H172C77.7,0,0,70.5,0,172.4c0,93.3,77.7,169.9,172,169.4h80.2 C345.5,342.3,430.6,265.6,430.6,172.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.5,14.4c-86.2,0-156.1,70.1-156.1,156.5c0,86.4,69.9,156.4,156.1,156.5c86.2,0,156.1-70.1,156.1-156.5 C328.7,84.5,258.8,14.5,172.5,14.4L172.5,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.9,170.5c0.1-42.2,26.4-78.3,63.5-92.6v185.1C100.3,248.8,73.9,212.8,73.9,170.5L73.9,170.5z M208.2,263.1 V78c37.1,14.3,63.5,50.3,63.6,92.6C271.7,212.8,245.4,248.8,208.2,263.1L208.2,263.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.8b217f3d14a71a1df97df206d6121716.svg";
export { ForwardRef as ReactComponent };